module.exports = __webpack_public_path__ + "img/13.852f21ee.jpg";